import { h } from 'preact'

export default function NoResults({ title, text }) {
	return (
		<div className="no-results">
			{title && <span className="no-results__title">{title}</span>}
			{text && <span className="no-results__text">{text}</span>}
		</div>
	)
}
